const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "onboarding-copy-3",
  transform: "translate(-588.000000, -237.000000)",
  stroke: "#F89E0A",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Online_Shopping",
  transform: "translate(589.000000, 238.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "27.8 28.23 91.01 28.23 79.04 69.03 39.28 69.03"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 45.51,
  cy: 84.72,
  r: 6.28
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 72.18,
  cy: 84.72,
  r: 6.28
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L17.84,0 C19.006281,0.048242025 20.02129,0.812484091 20.39,1.92 L39.29,69",
  id: "Path"
}))));
function SvgIterableCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "93px",
    viewBox: "0 0 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Online_Shopping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIterableCart);
export default __webpack_public_path__ + "static/media/iterable-cart.08b3c6100751f0c2f9946b2f6bac7e39.svg";
export { ForwardRef as ReactComponent };